module.exports = __webpack_public_path__ + "img/pic_wxzf.444d9c7f.png";